import { FileInput } from '@mantine/core';
import { IconFile } from '@tabler/icons-react';
import { FieldValues, useController } from 'react-hook-form';

import { FormControlInput } from '@/core/components';

export interface FileInputControlProps<T extends FieldValues> extends FormControlInput<T> {
  withAsterisk?: boolean;

  label: string;
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;
  accept: string;
}

export function FileInputControl<T extends FieldValues>(props: FileInputControlProps<T>) {
  const { withAsterisk, label, placeholder, description, name, isSubmitting, isDisabled, accept, control } = props;
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  return (
    <FileInput
      ref={field.ref}
      name={field.name}
      value={field.value}
      onChange={field.onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      withAsterisk={withAsterisk}
      error={error?.message}
      disabled={isSubmitting || isDisabled}
      flex={1}
      leftSection={<IconFile size="20px" />}
      accept={accept}
    />
  );
}
